export function defined<T>(t: T | undefined | null, message: string): T {
  if (t === null || t === undefined) {
    const error = "Unexpected missing value";
    throw new Error(`${error}: ${message}`);
  }
  return t;
}
